<template>
    <div>
        <div class="banner">
            <div class="headerReplacementInformation"></div>
            <div class="banner-text">
                <b>ติดต่อนักลงทุนสัมพันธ์</b>
                <div class="breadcrumb">
                    <span><router-link to="/" class="pe-auto">หน้าหลักนักลงทุนสัมพันธ์</router-link></span>
                    <span class="separator"></span>
                    <span>สอบถามข้อมูล</span>
                    <span class="separator"></span>
                    <span><b>ติดต่อนักลงทุนสัมพันธ์</b></span>
                </div>
            </div>
        </div>

        <div class="container mb-5">
            <div class="TabMenu">
                <InformationTabMenu />
            </div>

            <div class="row mt-5">
                <div class="col-md-4 mb-3">
                    <div class="mb-5"><img src="../../assets/logo_origin_og.png"></div>
                    <div class="mb-3">
                        <h4><b>ติดต่อนักลงทุนสัมพันธ์</b></h4>
                    </div>
                    <div>โทรศัพท์ : 081-1311064</div>
                    <div>โทรสาร : 02-3988066</div>
                    <div>อีเมล : ir@origin.co.th</div>
                </div>
                <div class="col-md-8">
                    <div class="card border border-0 rounded-0">
                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-md">
                                    <label class="form-label">ชื่อ*</label>
                                    <input v-model="form.name" type="text" class="form-control" placeholder="กรอกชื่อ" />
                                    <span v-if="errorMessage.name" class="text-danger">{{ errorMessage.name }}</span>
                                </div>
                                <div class="col-md">
                                    <label class="form-label">นามสกุล*</label>
                                    <input v-model="form.surname" type="text" class="form-control"
                                        placeholder="กรอกนามสกุล" />
                                    <span v-if="errorMessage.surname" class="text-danger">{{ errorMessage.surname }}</span>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md">
                                    <label class="form-label">เบอร์โทรศัพท์*</label>
                                    <input v-model="form.phone" type="text" class="form-control"
                                        placeholder="ตัวอย่าง 088xxxxxxx" />
                                    <span v-if="errorMessage.phone" class="text-danger">{{ errorMessage.phone }}</span>
                                </div>
                                <div class="col">
                                    <label class="form-label">แฟกซ์*</label>
                                    <input v-model="form.fax" type="text" class="form-control"
                                        placeholder="ตัวอย่าง 02xxxxxxx" />
                                    <span v-if="errorMessage.fax" class="text-danger">{{ errorMessage.fax }}</span>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md">
                                    <label class="form-label">ที่อยู่**</label>
                                    <input v-model="form.address" type="text" class="form-control" placeholder="" />
                                    <span v-if="errorMessage.address" class="text-danger">{{ errorMessage.address }}</span>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md">
                                    <label class="form-label">รายละเอียด</label>
                                    <textarea v-model="form.message" class="form-control"
                                        placeholder="พิมพ์ข้อความของคุณที่นี่ !" rows="3"></textarea>
                                    <span v-if="errorMessage.message" class="text-danger">{{ errorMessage.message }}</span>
                                </div>
                            </div>
                            <div class="d-grid gap-2 col-4 mx-auto">
                                <button @click="save" class="btn btn-primary" type="button">ส่งข้อความ</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import InformationTabMenu from '@/components/InformationTabMenu.vue';
import { GET_CONTACT_INVESTOR } from "@/store/actions.type";
import store from "@/store";
import Swal from "sweetalert2/src/sweetalert2.js";

export default {
    name: 'Info',
    components: {
        InformationTabMenu,
    },
    data() {
        return {
            form: {
                name: '',
                surname: '',
                phone: '',
                fax: '',
                address: '',
                message: ''
            },
            errorMessage: {}, 
        };
    },
    methods: {
        validateForm(form) {
            let errors = {};

            if (!form.name) {
                errors.name = "กรุณากรอกชื่อ";
            }
            if (!form.surname) {
                errors.surname = "กรุณากรอกนามสกุล";
            }
            if (!form.phone || !/^\d{10}$/.test(form.phone)) {
                errors.phone = "กรุณากรอกเบอร์โทรศัพท์ที่ถูกต้อง";
            }
            if (!form.fax || !/^\d{9,10}$/.test(form.fax)) {
                errors.fax = "กรุณากรอกแฟกซ์ที่ถูกต้อง";
            }
            if (!form.address) {
                errors.address = "กรุณากรอกที่อยู่";
            }
            if (!form.message) {
                errors.message = "กรุณากรอกรายละเอียด";
            }

            return Object.keys(errors).length > 0 ? errors : null;
        },

        async save() {
            // Validate the form before saving
            let errorMessage = this.validateForm(this.form);

            if (errorMessage) {
                this.errorMessage = errorMessage;
                return; 
            } else {
                this.errorMessage = {}; 
            }

            let form = {
                name: this.form.name,
                surname: this.form.surname,
                phone: this.form.phone,
                fax: this.form.fax,
                address: this.form.address,
                message: this.form.message,
            };

            try {
                let response = await store.dispatch(GET_CONTACT_INVESTOR, form);

                if (response === 'Email sent successfully') {
                    Swal.fire({
                        text: 'ส่งข้อความสำเร็จแล้ว',
                        icon: 'success',
                        confirmButtonColor: "#E87D2E",
                        confirmButtonText: 'ตกลง',
                        customClass: {
                            confirmButton: "btn-primary"
                        }
                    });
                    this.form = ""
                } else {
                    Swal.fire({
                        text: 'มีปัญหาในการส่งข้อความ กรุณาลองใหม่อีกครั้ง',
                        icon: 'error',
                        confirmButtonColor: "#E87D2E",
                        confirmButtonText: 'ตกลง',
                        customClass: {
                            confirmButton: "btn-primary"
                        }
                    });
                }
            } catch (error) {
                Swal.fire({
                    text: 'เกิดข้อผิดพลาดในการประมวลผลคำขอของคุณ กรุณาลองใหม่ในภายหลัง',
                    icon: 'error',
                    confirmButtonColor: "#E87D2E",
                    confirmButtonText: 'ตกลง',
                    customClass: {
                        confirmButton: "btn-primary"
                    }
                });
            }

            this.$emit("closePanel", { confirm: true });
        }

    },
};
</script>
  
<style scoped>
h2.mt-5 {
    display: inline-block;
    border-bottom: 3px solid #E87D2E;
    padding-bottom: 5px;
}

.card-pdf {
    box-shadow: 0px 4px 10px 0px #0000000D;
    border: none;
}

.card {
    background-color: #F2F2F2;
}

.vertical-line {
    width: 4px;
    background-color: #E87D2E;
    margin-left: 30px;
    height: 40%;
    margin-top: 10px;
}

th {
    font-weight: normal;
}

.table {
    margin-bottom: 0;
}

.text-danger {
    font-size: 12px;
    color: red;
}
</style>
  